import axios from 'axios';
import {
  useCallback,
} from 'react';

import { baseUrl } from '../helpers/urls';
import { useCurrentUser } from '../contexts/CurrentUser.context';

const useCompanies = () => {

  const {token} = useCurrentUser();

  const authHeader = useCallback(() => ({
    Authorization: `Bearer ${token}`,
  }), [token]);

  // Levert enkel de bedrijven waar je zelf een rol in hebt.
  const getAll = useCallback(async () => {
    const response = await axios.get(`${baseUrl}/companies`, {
      headers: authHeader(),
    });

    return response.data;
  }, [authHeader]);

  const getById = useCallback(async (code) => {
    const response = await axios.get(`${baseUrl}/companies/${code}`, {
      headers: authHeader(),
    });

    return response.data;
  }, [authHeader]);

  const create = useCallback(async (name, street, number, postalcode, city, country) => {
    const response = await axios({
      method: 'POST',
      url: `${baseUrl}/companies`,
      data: {name, street, number, postalcode, city, country},
      headers: authHeader(),
    });

    return response.data;
  }, [authHeader]);

  const deleteComp = useCallback(async (code) => {
    const response = await axios.delete(`${baseUrl}/companies/${code}`, {
      headers: authHeader(),
    });

    return response.data;
  }, [authHeader]);

  return {
    getAll,
    getById,
    create,
    deleteComp
  };
};

export default useCompanies;
